class Menu {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-myaccount-menu="scope"]',
			select: '[data-myaccount-menu="select"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initEventListeners();
	}

	initEventListeners() {
		this.$scope.on('change', this.config.select, this.changeUrlBySelect.bind(this));
	}

	changeUrlBySelect(event) {
		let $select = $(event.currentTarget);
		this.changeUrl($select.val());
	}

	changeUrl(url) {
		window.location.href = url;
	}
}

export default Menu;